import { useNavigate } from "flemo";
import { useEffect } from "react";

import { useOnboardingStatusQuery } from "@/hooks/queries";
import { AuthStatus } from "@/lib/constant";
import { useAuthStore } from "@/store/authStore";

type AuthGuardProps = {
  children: React.ReactNode;
  allowIncompleteOnboarding?: boolean;
};

export function AuthGuard({ children, allowIncompleteOnboarding = false }: AuthGuardProps) {
  const { replace } = useNavigate();
  const user = useAuthStore(state => state.user);
  const status = useAuthStore(state => state.status);
  const shouldCheckOnboarding = status === AuthStatus.AUTHENTICATED && Boolean(user) && !allowIncompleteOnboarding;
  const onboarding = useOnboardingStatusQuery(shouldCheckOnboarding);

  useEffect(() => {
    if (status === AuthStatus.UNAUTHENTICATED) {
      replace("/login", {}, { transitionName: "none" });
    }
  }, [replace, status]);

  useEffect(() => {
    if (shouldCheckOnboarding && onboarding.isSuccess && !onboarding.data.isCompleted) {
      replace("/onboarding", {}, { transitionName: "none" });
    }
  }, [onboarding.data?.isCompleted, onboarding.isSuccess, replace, shouldCheckOnboarding]);

  if (status === AuthStatus.LOADING) {
    return null;
  }

  if (!user) {
    return null;
  }

  if (shouldCheckOnboarding && (onboarding.isPending || (onboarding.isSuccess && !onboarding.data.isCompleted))) {
    return null;
  }

  return <>{children}</>;
}
